import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
    Combo2Service,
    DCService
} from "../../../services/index";
import { PrintData } from "../../master/print/print";
import { JGRNService } from "../../../services/jgrn.service";
declare var google;

@Component({
  selector: "sampleToBitConvertGrn",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./sampleToBitConvertGrn.html",
})
export class sampleToBitConvertGrn implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  data: any;
  remainList: any;
  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  printData;
  filter = {
    dc_no: "",
    // dc_date: '',
    finyear: "2020-2021",
    design_no: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "converted_date",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("printTemplate") printTemplate: TemplateRef<any>;


  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  dcdata: any = [];
  dcdata1: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public dcservice: DCService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
    private jgrn: JGRNService,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    this.data = {
      dcdata: [],
      dcdata1: [],
    };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Converted Date",
        prop: "converted_date",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Barcode",
        prop: "barcode",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Design No",
        prop: "fab_design",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Color",
        prop: "color",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Mtrs",
        prop: "mtr",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Converted",
        prop: "converted",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "BARCODE",
        prop: "sno",
        minWidth: 100,
        maxWidth: 100,
        headerClass: "text-center",
        width: 100,
        sortable: false,
        cellTemplate: this.printTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);
    this.finyearCombo();
    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#section").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getSampleToBitConvertedList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    // this.filter.dc_date = '';
    this.filter.design_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getSampleToBitConvertedList();
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
    });
  }
  getSampleToBitConvertedList(): void {
    // if (this.filter.dc_date == '') {
    // this.filter.dc_date == '';
    // }
    // else {
    // this.filter.dc_date = this.datePipe.transform(this.filter.dc_date, 'yyyy-MM-dd');
    // }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      // dc_date: this.filter.dc_date,
      finyear: this.filter.finyear,
      design_no: this.filter.design_no,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.dcservice
      .getSampleToBitConvertedList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.dcdata = res.data;
      });
  }

  addEditDC(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getSampleToBitConvertedList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          tabName: "CONVERT SAMPLE/SWATCH TO BIT",
          title: "CONVERT SAMPLE/SWATCH TO BIT",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "addEditsampleToBitConvertGrn",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  // printremainlist(row) {
  //   let params = {
  //     dc_id: row.dc_id,
  //   };

  //   this.dcservice.remainList(params).then((res: any) => {
  //     this.data.dcdata = res.data;
  //     this.clickPrint(row, res.data);
  //     console.log(res.data);
  //   });
  //   this.dcservice.availList(params).then((res: any) => {
  //     this.data.dcdata1 = res.data;
  //     console.log(res.data);
  //     if (res.data.length != 0) {
  //       this.clickPrintavail(row, res.data);
  //     }
  //   });
  // }
  loadeditJGRNPrintList(rows) {
      let that = this;
      var row  = rows;
      // that.calcTotal();
      // that.calcQty();
      if(row.jgrnType == 'BIT'){
        swal({
          title: "Please ensure that Small Sticker roll (Bit Roll) was inserted...",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok"
        }).then(() => {
          let data = [];
          data.push(Object.assign({}, row));
          that.clickPrint(row, data);
        });
      }
      
  }
  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.jgrn.jgrnprint(params).then(function (res: any) {});
  }
  // printavaillist(row){
  //     let params = {
  //         dc_id: row.dc_id,
  //     };
  //

  //     this.dcservice
  //         .availList(params)
  //         .then((res: any) => {
  //             this.data.dcdata = res.data;
  //             this.clickPrint(row,res.data);
  //

  //         });
  // }

  // clickPrint(row, data) {
  //   let that = this;
  //   let params: any = Object.assign({}, row);
  //   params["data"] = JSON.stringify(data);
  //   that.isLoadMask = that.dcservice
  //     .dcremainPrint(params)
  //     .then(function (res: any) {});
  // }
  // clickPrintavail(row, data) {
  //   let that = this;
  //   let params: any = Object.assign({}, row);
  //   params["data"] = JSON.stringify(data);

  //   that.isLoadMask = that.dcservice
  //     .dcavailPrint(params)
  //     .then(function (res: any) {});
  // }

  deleteDC(row: any): void {
    row.tabevent = undefined;
    let that = this;
    swal({
      title: "Are you sure to delete this DC Details?",
      text: "You will not be able to recover this DC" + " " + row["dc_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.dcservice
          .deleteDC(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getSampleToBitConvertedList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
  bsModalRef: BsModalRef;
  printDc(row) {
    row.printType = "details";

    this.dcservice.purchaseDcPrint(row).then((res: any) => {
      // let var = "<div>aaaa</div>"
      this.printData = res;
      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printdet = this.printData;
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sampleToBitConvertGrn/sampleToBitConvertGrn.ts